import * as types from '../../actions/actionsTypes/timbraturaActionsType';

export const initialStateTimbrature = {
    timbrature: [],
    timbratureManualiEnd: false,
    timbraturaDettaglio: null,
    error: []
};

export const timbratureReducer = (state = initialStateTimbrature, action) => {
    switch (action.type) {
        case types.INIT_TIMBRATURE :
            return {
                timbrature: [],
                timbratureManualiEnd: false,
                timbraturaDettaglio: null,
                error: []
            };

        case types.RICERCA_TIMBRATURE_SINGOLO_INDIVIDUO_END : {
            return {
                ...state,
                timbrature: action.timbrature,
                error: action.error
            }
        }

        case types.ADD_TIMBRATURA_AUTOMATICA_END:
            return {
                ...state,
                timbrature: [],
                timbratureManualiEnd: true,
                error: action.errors
            };

        case types.ADD_TIMBRATURA_MANUALE_END:
            return {
                ...state,
                timbrature: [],
                timbratureManualiEnd: true,
                error: action.errors
            };

        case types.DELETE_TIMBRATURA_SUCCESS:
            return {
                ...state,
                timbrature: [],
                timbratureManualiEnd: true,
                error: action.errors
            };


        case types.TIMBRATURA_RECUPERA_DETTAGLIO_SUCCESS : {
            return {
                ...state,
                timbraturaDettaglio: action.timbraturaDettaglio,
            };
        }

        default:
            return state
    }
};
